<p-toast></p-toast>

<app-page-shell>

    <app-page-hero
        eyebrow="Fleet Mobilization"
        title="Approval Queue"
        subtitle="Submitted assignments await approval; rejected assignments can be corrected and resubmitted.">
        <div nav>
            <p-button label="Overview" icon="pi pi-chart-line" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization"></p-button>
            <p-button label="Entries" icon="pi pi-list" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization/entries"></p-button>
            <p-button label="Approvals" icon="pi pi-check-square" routerLink="/fleet/mobilization/change-requests"></p-button>
            <p-button label="History" icon="pi pi-history" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization/history"></p-button>
        </div>
        <div actions>
            <p-button label="New Mobilization" icon="pi pi-plus" routerLink="/fleet/mobilization/new"></p-button>
        </div>
    </app-page-hero>

    <app-page-search-panel
        title="Approval Search"
        [activeFilters]="activeFilterCount()"
        [resultText]="submitted.length + rejected.length + ' queue items'"
        [collapsed]="false"
        (search)="loadQueue()"
        (clear)="clearSearch()">
        <div class="search-grid">
            <div class="field">
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-search"></i></p-inputgroup-addon>
                    <p-iftalabel>
                        <input id="approval-keyword" pInputText [(ngModel)]="keyword" placeholder="Driver, vehicle, project, site" />
                        <label for="approval-keyword">Keyword</label>
                    </p-iftalabel>
                </p-inputgroup>
            </div>
        </div>
    </app-page-search-panel>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-data-panel title="Submitted for Approval" subtitle="One-step approval decisions for mobilization assignments." [resultText]="submitted.length + ' submitted'">
        <p-table [value]="submitted" [loading]="isLoading" styleClass="p-datatable-sm" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Assignment</th>
                    <th>Status</th>
                    <th>Driver</th>
                    <th>Truck</th>
                    <th>Trailer</th>
                    <th>Project</th>
                    <th>Dates</th>
                    <th>Salary</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td class="font-semibold">{{ row.mobilizationNumber || ('MOB-' + row.mobilizationId) }}</td>
                    <td><p-tag [value]="row.status" [severity]="statusSeverity(row.status)"></p-tag></td>
                    <td>{{ row.driverName || '-' }}</td>
                    <td>{{ row.vehiclePlateNumber || row.vehicleRegistrationNumber || '-' }}</td>
                    <td>{{ trailerLabel(row) }}</td>
                    <td>{{ projectLabel(row) }}</td>
                    <td>{{ dateLabel(row.startDate) }} - {{ dateLabel(row.endDate) }}</td>
                    <td>{{ salaryLabel(row) }}</td>
                    <td class="text-right"><p-button label="Review" icon="pi pi-arrow-up-right" [text]="true" (onClick)="openRequest(row)"></p-button></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="9" class="empty-cell">No submitted mobilizations.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>

    <app-page-data-panel title="Rejected Assignments" subtitle="Returned assignments that can be edited and resubmitted." [resultText]="rejected.length + ' rejected'">
        <p-table [value]="rejected" [loading]="isLoading" styleClass="p-datatable-sm" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Assignment</th>
                    <th>Status</th>
                    <th>Driver</th>
                    <th>Truck</th>
                    <th>Trailer</th>
                    <th>Project</th>
                    <th>Dates</th>
                    <th>Salary</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td class="font-semibold">{{ row.mobilizationNumber || ('MOB-' + row.mobilizationId) }}</td>
                    <td><p-tag [value]="row.status" [severity]="statusSeverity(row.status)"></p-tag></td>
                    <td>{{ row.driverName || '-' }}</td>
                    <td>{{ row.vehiclePlateNumber || row.vehicleRegistrationNumber || '-' }}</td>
                    <td>{{ trailerLabel(row) }}</td>
                    <td>{{ projectLabel(row) }}</td>
                    <td>{{ dateLabel(row.startDate) }} - {{ dateLabel(row.endDate) }}</td>
                    <td>{{ salaryLabel(row) }}</td>
                    <td class="text-right"><p-button label="Open" icon="pi pi-arrow-up-right" [text]="true" (onClick)="openRequest(row)"></p-button></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="9" class="empty-cell">No rejected mobilizations.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
